import { normalizeUserQuantity } from "../../../normalizers/normalizeUserQuantity";

export function handleUserParentQDUpdated(state, payload) {
    const { quantities } = payload;

    const quantitiesById = {
        ...state.quantitiesById,
    };

    for (const q of quantities) {
        const normalized = normalizeUserQuantity(q);
        quantitiesById[normalized.nodeId] = {
            ...quantitiesById[normalized.nodeId],
            ...normalized,
        };
    }

    return {
        ...state,
        quantitiesById,
    };


}